import type { LoraSetting, Segment } from '../types'

const candidateNames = (highName: string): string[] => {
  const replacements: Array<[RegExp, string]> = [
    [/HighNoise/g, 'LowNoise'],
    [/_High/g, '_Low'],
    [/-H(?=\.|$)/g, '-L'],
  ]
  return replacements
    .filter(([pattern]) => pattern.test(highName))
    .map(([pattern, replacement]) => highName.replace(pattern, replacement))
}

export function findPairedLowLora(highName: string, lowOptions: string[]): string | null {
  if (!highName || highName === 'None') return null
  const optionSet = new Set(lowOptions)
  const matches = [...new Set(candidateNames(highName))].filter((candidate) => optionSet.has(candidate))
  return matches.length === 1 ? matches[0] : null
}

export function normalizeLoraRows(rows: unknown, count = 4): LoraSetting[] {
  const source = Array.isArray(rows) ? rows : []
  return Array.from({ length: count }, (_, index) => {
    const row = source[index]
    if (!row || typeof row !== 'object') return { name: '', strength: 1 }
    const candidate = row as { name?: unknown; strength?: unknown }
    const strength = Number(candidate.strength)
    return {
      name: typeof candidate.name === 'string' ? candidate.name : '',
      strength: Number.isFinite(strength) ? strength : 1,
    }
  })
}

const hasConfiguredLora = (rows: LoraSetting[]): boolean =>
  rows.some((row) => Boolean(row.name && row.name !== 'None'))

export function enableSegmentCustomLora(segment: Segment, globalHigh: LoraSetting[], globalLow: LoraSetting[]): Segment {
  if (segment.lora_mode === 'custom') return segment
  const hasSavedCustom = hasConfiguredLora(segment.lora_high) || hasConfiguredLora(segment.lora_low)
  return {
    ...segment,
    lora_mode: 'custom',
    lora_high: (hasSavedCustom ? segment.lora_high : globalHigh).map((row) => ({ ...row })),
    lora_low: (hasSavedCustom ? segment.lora_low : globalLow).map((row) => ({ ...row })),
  }
}
